import type { Post } from '@/@types/post'
import { MEDIA_META } from '@/constants/api'
import { post as axiosPost } from '@/utils/request'
import type { PostProps } from '@ruguoapp/jike-fe-components'
import { useQuery } from '@tanstack/react-query'
import { isEqual, merge } from 'lodash-es'
import { memo } from 'react'
import { useInView } from 'react-intersection-observer'
import PictureGrid from '../PictureGrid'
import TextContent from '../TextContent'
import LinkCard from './PostTargetCard/LinkCard'
import PostVideo from './PostVideo'

export interface PostContentProps extends PostProps {
	data: Post
	mode?: 'simple' | 'full'
}

export default memo(function PostContent({ data, mode = 'simple', ...props }: PostContentProps) {
	const isSimpleMode = mode === 'simple'
	const post = merge(
		{},
		{
			urlsInText: [],
		},
		data
	) as Post

	const { ref: videoRef, inView: isVideoInView } = useInView()

	const { data: videoURL } = useQuery({
		queryKey: [MEDIA_META, post.id],
		queryFn: async () =>
			axiosPost(
				MEDIA_META,
				{},
				{
					params: {
						id: post.id,
						type: post.type,
					},
				}
			).then((res) => res.data.url),
		enabled: isVideoInView && !!post.id && !!post.video,
	})

	return (
		<>
			<TextContent
				content={data.content}
				urlsInText={data.urlsInText}
				autoCollapsable={mode === 'simple'}
			/>

			{post.linkInfo && <LinkCard data={post.linkInfo} />}
			{post.pictures && <PictureGrid data={post.pictures} mode="complex" />}

			{post.video && <PostVideo src={videoURL} poster={post.video.thumbnailUrl} ref={videoRef} />}
		</>
	)
}, isEqual)
